import { Component } from '@angular/core';

@Component({
  selector: 'brt-overlay-window-content',
  templateUrl: './overlay-window-content.component.html',
  styleUrls: ['./overlay-window-content.component.scss']
})
export class OverlayWindowContentComponent {

}
